export const enUS_commonMenu = {
  'menu.common.search': 'Search',
  'menu.common.reset': 'Reset',
  'menu.common.registration': 'Registration',
  'menu.common.update': 'Update',
  'menu.common.delete': 'Delete',
   'menu.common.filter': 'Filter',
};
